var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 0C4.68632 0 2.00003 2.68629 2.00003 6V9.58579L1.29292 10.2929C1.00692 10.5789.921369 11.009 1.07615 11.3827 1.23093 11.7564 1.59557 12 2.00003 12H14C14.4045 12 14.7691 11.7564 14.9239 11.3827 15.0787 11.009 14.9931 10.5789 14.7071 10.2929L14 9.58579V6C14 2.68629 11.3137 0 8.00003 0zM8 16C6.34315 16 5 14.6569 5 13H11C11 14.6569 9.65685 16 8 16z",
    fill: "currentColor"
  })));
}

export default SvgBell;